/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type SelectPlayersQueryVariables = {|
  slateID: string,
  gmID: string,
|};
export type SelectPlayersQueryResponse = {|
  +playersForSlate: ?$ReadOnlyArray<?{|
    +id: string,
    +player: {|
      +id: string,
      +name: string,
      +shortenedName: ?string,
      +team: ?{|
        +abbreviation: string,
        +name: ?string,
      |},
    |},
    +position: ?string,
    +fppg: any,
    +salary: number,
    +rosterSlots: {|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +name: string
        |}
      |}>
    |},
    +slateCompetition: ?{|
      +prettyStartTime: ?string
    |},
    +gupPercProj: ?any,
    +projPoints: ?any,
    +suffix: ?string,
  |}>,
  +greenMachineSession: ?{|
    +id: string,
    +user: {|
      +username: string
    |},
    +slate: {|
      +prettyStartTime: ?string
    |},
    +selectedPlayerIds: ?$ReadOnlyArray<?string>,
    +numLineups: number,
  |},
|};
export type SelectPlayersQuery = {|
  variables: SelectPlayersQueryVariables,
  response: SelectPlayersQueryResponse,
|};
*/


/*
query SelectPlayersQuery(
  $slateID: ID!
  $gmID: ID!
) {
  playersForSlate(slateId: $slateID) {
    id
    player {
      id
      name
      shortenedName
      team {
        abbreviation
        name
        id
      }
    }
    position
    fppg
    salary
    rosterSlots {
      edges {
        node {
          name
          id
        }
      }
    }
    slateCompetition {
      prettyStartTime
      id
    }
    gupPercProj
    projPoints
    suffix
  }
  greenMachineSession(id: $gmID) {
    id
    user {
      username
      id
    }
    slate {
      prettyStartTime
      id
    }
    selectedPlayerIds
    numLineups
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "gmID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "slateID"
},
v2 = [
  {
    "kind": "Variable",
    "name": "slateId",
    "variableName": "slateID"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortenedName",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "abbreviation",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "position",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fppg",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "salary",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "prettyStartTime",
  "storageKey": null
},
v11 = [
  (v10/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gupPercProj",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "projPoints",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "suffix",
  "storageKey": null
},
v15 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "gmID"
  }
],
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "username",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectedPlayerIds",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "numLineups",
  "storageKey": null
},
v19 = [
  (v10/*: any*/),
  (v3/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SelectPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterSlotTypeConnection",
            "kind": "LinkedField",
            "name": "rosterSlots",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionType",
            "kind": "LinkedField",
            "name": "slateCompetition",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineSession",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v16/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": (v11/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "SelectPlayersQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SlatePlayerType",
        "kind": "LinkedField",
        "name": "playersForSlate",
        "plural": true,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "PlayerType",
            "kind": "LinkedField",
            "name": "player",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "TeamType",
                "kind": "LinkedField",
                "name": "team",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  (v4/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "RosterSlotTypeConnection",
            "kind": "LinkedField",
            "name": "rosterSlots",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "RosterSlotTypeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RosterSlotType",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateCompetitionType",
            "kind": "LinkedField",
            "name": "slateCompetition",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v15/*: any*/),
        "concreteType": "GreenMachineSessionType",
        "kind": "LinkedField",
        "name": "greenMachineSession",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserType",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v16/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SlateType",
            "kind": "LinkedField",
            "name": "slate",
            "plural": false,
            "selections": (v19/*: any*/),
            "storageKey": null
          },
          (v17/*: any*/),
          (v18/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "aa543d971c50db8e42941e5aa6221076",
    "id": null,
    "metadata": {},
    "name": "SelectPlayersQuery",
    "operationKind": "query",
    "text": "query SelectPlayersQuery(\n  $slateID: ID!\n  $gmID: ID!\n) {\n  playersForSlate(slateId: $slateID) {\n    id\n    player {\n      id\n      name\n      shortenedName\n      team {\n        abbreviation\n        name\n        id\n      }\n    }\n    position\n    fppg\n    salary\n    rosterSlots {\n      edges {\n        node {\n          name\n          id\n        }\n      }\n    }\n    slateCompetition {\n      prettyStartTime\n      id\n    }\n    gupPercProj\n    projPoints\n    suffix\n  }\n  greenMachineSession(id: $gmID) {\n    id\n    user {\n      username\n      id\n    }\n    slate {\n      prettyStartTime\n      id\n    }\n    selectedPlayerIds\n    numLineups\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b1ac6babc184b526e90fb951aef5f07';

module.exports = node;
